import { keepPreviousData } from '@tanstack/react-query';

import { ApprovalRequestState } from '../../types/ApprovalRequestState';
import { queries } from '../common/api/queryKeys/queries';
import { usePaginationQuery } from '../common/hooks/usePaginationQuery';

import { OrderModel } from './model/OrderModel';

interface useOrderPaginationProps {
    page?: number;
    searchQuery?: string;
    customerIds?: string[];
    supplierIds?: string[];
    offerStates?: string[];
    read?: boolean;
    states?: string[];
    approvalRequestStates?: ApprovalRequestState[];
    sortField?: string;
    sortDirection?: string;
}

export const useOrderPagination = ({ page = 0, ...rest }: useOrderPaginationProps) => {
    const nextPage = queries.orders.pagination({ page: page + 1, ...rest });

    return usePaginationQuery<OrderModel>({
        ...queries.orders.pagination({ page, ...rest }),
        options: { placeholderData: keepPreviousData },
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
